import { useMutation } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

import { CoveragePeriodRequest, ManualContributionCoveragePeriodsByEmployeeIdPlanCode } from '../types';

export const GET_MANUAL_CONTRIBUTION_COVERAGE_PERIOD_QUERY_KEY =
  'GET_MANUAL_CONTRIBUTION_COVERAGE_PERIOD_QUERY_KEY';

interface Props {
  contributionDate: string;
  requestData: CoveragePeriodRequest[];
}

const useGetManualContributionCoveragePeriodQuery = () => {
  const mutation = useMutation(
    ({ contributionDate, requestData }: Props) =>
      // TODO: should be ICoveragePeriodDto but break things
      api.post<ManualContributionCoveragePeriodsByEmployeeIdPlanCode>(
        API_URL.MANUAL_CONTRIBUTION_COVERAGE_PERIODS,
        requestData,
        {
          params: {
            contribution_date: contributionDate,
          },
        }
      ),
    {
      mutationKey: [GET_MANUAL_CONTRIBUTION_COVERAGE_PERIOD_QUERY_KEY],
    }
  );

  return {
    getCoveragePeriod: mutation.mutate,
    getCoveragePeriodAsync: mutation.mutateAsync,
    data: mutation.data?.data,
    isLoading: mutation.isLoading,
    error: mutation.error,
    isError: mutation.isError,
    isSuccess: mutation.isSuccess,
    reset: mutation.reset,
  };
};

export default useGetManualContributionCoveragePeriodQuery;
